export const audios = {
  success: require('./success.mp3'),
  error: require('./error.mp3'),
};
